import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';
import { Spinner } from '../../commonComponents/Spinner';
import { useGetPromotions } from '../../../domain/Promotions';
import { PromotionRow } from './PromotionRow';
import { COLORS, PAYOUT_GRID_COLUMNS } from './constants';

const headerCellStyle = {
  padding: '0 15px',
  display: 'flex',
  alignItems: 'center',
  fontWeight: 700,
  fontSize: 16,
  color: COLORS.text,
};

export const PromotionsTab = ({
  onAddPromotion,
  onEditPromotion,
  onAddPayout,
  onReactivate,
  onViewReport,
}) => {
  const { promotions, isLoading, isError } = useGetPromotions();

  return (
    <div
      style={{
        backgroundColor: '#fff',
        border: `1px solid ${COLORS.cardBorder}`,
        borderRadius: 2.5,
        padding: 21,
        position: 'relative',
      }}
    >
      <h2
        style={{
          textAlign: 'center',
          fontSize: 30,
          color: COLORS.text,
          margin: '12px 0 24px',
        }}
      >
        Promotion
      </h2>

      <button
        type="button"
        onClick={() => onAddPromotion?.()}
        style={{
          position: 'absolute',
          top: 44,
          right: 21,
          backgroundColor: COLORS.addButtonBg,
          border: `1px solid ${COLORS.addButtonBorder}`,
          borderRadius: 4,
          color: '#fff',
          fontSize: 14,
          padding: '7px 14px',
          cursor: 'pointer',
        }}
      >
        + Add Promotion
      </button>

      {/* Column header */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: PAYOUT_GRID_COLUMNS,
          backgroundColor: COLORS.headerBg,
          minHeight: 53,
        }}
      >
        <div style={headerCellStyle}>Date</div>
        <div style={headerCellStyle}>Uploaded by</div>
        <div style={{ ...headerCellStyle, justifyContent: 'center' }}>Payout Succeeded</div>
        <div style={{ ...headerCellStyle, justifyContent: 'center' }}>Payout Failed</div>
      </div>

      {isLoading && <Spinner />}

      {isError && (
        <Alert
          type="error"
          style={{ marginTop: 16 }}
          message="Unable to load promotions"
          description="You may not have access to this tool, or the service is unavailable."
        />
      )}

      {!isLoading && !isError && promotions.length === 0 && (
        <div style={{ padding: '24px 15px', color: COLORS.text }}>
          No promotions yet. Create one with “+ Add Promotion”.
        </div>
      )}

      {!isLoading &&
        !isError &&
        promotions.map((promotion) => (
          <PromotionRow
            key={promotion.id}
            promotion={promotion}
            onAddPayout={onAddPayout}
            onReactivate={onReactivate}
            onEdit={onEditPromotion}
            onViewReport={onViewReport}
          />
        ))}
    </div>
  );
};

PromotionsTab.propTypes = {
  onAddPromotion: PropTypes.func,
  onEditPromotion: PropTypes.func,
  onAddPayout: PropTypes.func,
  onReactivate: PropTypes.func,
  onViewReport: PropTypes.func,
};

PromotionsTab.defaultProps = {
  onAddPromotion: undefined,
  onEditPromotion: undefined,
  onAddPayout: undefined,
  onReactivate: undefined,
  onViewReport: undefined,
};
